(() => {
  const SELECTOR = '[data-fb-site-browsing]';
  const timers = new WeakMap();

  const cairoHour = () => {
    try {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Africa/Cairo',
        hour: '2-digit',
        hour12: false
      }).formatToParts(new Date());
      return Number(parts.find((part) => part.type === 'hour')?.value || 0) % 24;
    } catch (_) {
      return new Date().getHours();
    }
  };

  const integer = (value, fallback) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const randomInt = (min, max) => {
    const low = Math.ceil(Math.min(min, max));
    const high = Math.floor(Math.max(min, max));
    return Math.floor(Math.random() * (high - low + 1)) + low;
  };

  const periodFor = (element) => {
    const hour = cairoHour();
    if (hour >= 6 && hour < 12) {
      return { key: 'morning', min: integer(element.dataset.morningMin, 600), max: integer(element.dataset.morningMax, 800) };
    }
    if (hour >= 12 && hour < 18) {
      return { key: 'afternoon', min: integer(element.dataset.afternoonMin, 450), max: integer(element.dataset.afternoonMax, 600) };
    }
    if (hour >= 18) {
      return { key: 'evening', min: integer(element.dataset.eveningMin, 300), max: integer(element.dataset.eveningMax, 450) };
    }
    return { key: 'night', min: integer(element.dataset.nightMin, 150), max: integer(element.dataset.nightMax, 280) };
  };

  const storageKey = (element, period) => `fb-site-browsing:v2:${element.id || 'global'}:${period.key}`;

  const loadState = (element, period) => {
    try {
      const stored = JSON.parse(sessionStorage.getItem(storageKey(element, period)) || 'null');
      if (stored && Number.isFinite(stored.value) && stored.value >= period.min && stored.value <= period.max) {
        return stored.value;
      }
    } catch (_) {}
    return randomInt(period.min, period.max);
  };

  const saveState = (element, period, value) => {
    try {
      sessionStorage.setItem(storageKey(element, period), JSON.stringify({ value, savedAt: Date.now() }));
    } catch (_) {}
  };

  const render = (element, value) => {
    const output = element.querySelector('[data-fb-site-browsing-count]');
    if (!output) return;
    const locale = document.documentElement.lang || 'en';
    output.textContent = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value);
  };

  const nextValue = (current, period) => {
    const middle = (period.min + period.max) / 2;
    let delta = randomInt(-7, 7);
    if (delta === 0) delta = Math.random() < .5 ? -2 : 2;

    // A small pull toward the middle prevents the counter from sticking to a boundary.
    if (current < middle - (period.max - period.min) * .28) delta = Math.abs(delta);
    if (current > middle + (period.max - period.min) * .28) delta = -Math.abs(delta);

    return Math.min(period.max, Math.max(period.min, current + delta));
  };

  const schedule = (element, state) => {
    const oldTimer = timers.get(element);
    if (oldTimer) window.clearTimeout(oldTimer);

    const minSeconds = integer(element.dataset.updateMin, 45);
    const maxSeconds = integer(element.dataset.updateMax, 75);
    const delay = randomInt(minSeconds, maxSeconds) * 1000;

    const timer = window.setTimeout(() => {
      const period = periodFor(element);
      if (period.key !== state.period.key) {
        state.period = period;
        state.value = loadState(element, period);
      } else {
        state.value = nextValue(state.value, period);
      }
      render(element, state.value);
      saveState(element, state.period, state.value);
      schedule(element, state);
    }, delay);

    timers.set(element, timer);
  };

  const initialise = (element) => {
    if (element.dataset.fbInitialised === 'true') return;
    element.dataset.fbInitialised = 'true';

    const period = periodFor(element);
    const state = { period, value: loadState(element, period) };
    render(element, state.value);
    saveState(element, period, state.value);
    schedule(element, state);

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return;
      const freshPeriod = periodFor(element);
      if (freshPeriod.key !== state.period.key) {
        state.period = freshPeriod;
        state.value = loadState(element, freshPeriod);
        render(element, state.value);
        saveState(element, freshPeriod, state.value);
      }
    });
  };

  const boot = (scope = document) => scope.querySelectorAll(SELECTOR).forEach(initialise);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
